module.exports = __webpack_public_path__ + "static/media/premium-tag.0334d9ba.svg";